import { useMutation, useQueryClient } from "@tanstack/react-query";
import { templateBuilderMutations } from "@/features/template-builder/mutations";
import { removeCachedTemplateStep } from "@/features/template-builder/queries/cache";

export function useDeleteStep(templateId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (stepId: string) =>
      templateBuilderMutations.deleteTemplateStep({ templateId, stepId }),
    onSuccess: ({ deleted_analysis_step_id: stepId }) => {
      removeCachedTemplateStep(queryClient, templateId, stepId);
    },
  });
}
